ACDiscountApp.PDPage.DisplayTiers = function () {
  this.DisplayTiersFn = function () {
   let productType = '';
   for (let i = 0; i < globalFields.product_type.length; i++) {
  let productType_ = globalFields.product_type[i];
  if (productType_ === 'Straight' || productType_ === 'Mixed') {
    productType = productType_;
    break;
  }
}
    var base_of_pack = globalFields.memberPrice.packandItem;
   var number_selection = globalFields.numberSelectionValue;
   let base_value = globalFields.memberPrice.BasePirce;
   let Compareatprice = globalFields.memberPrice.Compareatprice;
   let discountly_tier_price = globalFields.discountly_tier_price;
    var selected_item_array = globalFields.variantVisibility();
    var selectedVariantid = jQuery('input[name^=id]:checked, select[name^=id], input[name=id], hidden[name^=id]', jQuery('form[action="/cart/add"]')).val();
     if(!selectedVariantid){
       var variantSelectionElement = $('form[action="/cart/add"] .variant-selection');
       var variantValue = variantSelectionElement.attr('variant');
       selectedVariantid = variantValue;
     }
    
    var selected_item = selected_item_array[0];
    let tierObj = null;
    for (let mk = 0; mk < selected_item_array.length; mk++) {
    if(selectedVariantid == selected_item_array[mk].variant.id){
    selected_item = selected_item_array[mk].variant;
    }
    }
   let rrp_price = '';
   let non_member_price = '';
   let member_price = '';
   let compare_price = '';
   let base_price = '';
   let member_saving = '';
  if(discountly_tier_price != 'string'){
    tierObj = globalFields.GetTierObject(discountly_tier_price[0], selected_item.id);
  }
  if (base_of_pack === 'Item') {
    if (selected_item.compare_at_price && selected_item.compare_at_price > selected_item.price) {
        rrp_price = selected_item.compare_at_price;
        if (base_value === 'RRP Item') {
            base_price = rrp_price;
        }
    } else {
        rrp_price = selected_item.price;
        if (base_value === 'RRP Item') {
            base_price = rrp_price;
        }
    }
    
    non_member_price = selected_item.price * 1.00;
    if (base_value === 'Non Member Item') {
        base_price = non_member_price;
    }
} 
  else {
    // Pack of set
    if (selected_item.compare_at_price && selected_item.compare_at_price > selected_item.price) {
        rrp_price = selected_item.compare_at_price;
        if (base_value === 'RRP Total') {
            base_price = rrp_price;
        }
    } else {
        rrp_price = selected_item.price;
        if (base_value === 'RRP Total') {
            base_price = rrp_price;
        }
    }
    
    non_member_price = selected_item.price;
    if (base_value === 'Non Member Total') {
        base_price = non_member_price;
    }
}
    if(tierObj != undefined && tierObj != null){
      member_price = tierObj.tier_values[0] * 100;
      member_price =  member_price.toFixed(2);
    }

     let precision = number_selection.numberSelection;
     let precision_option = number_selection.valuePrice;
    if (precision === 'round') {
    precision_option = parseFloat(precision_option); // Convert to number if it's not already
    if (precision_option === 1) {
        rrp_pricenomoney = Math.round(rrp_price / 100.00);
        non_member_pricenomoney = Math.round(non_member_price / 100.00);
        member_pricenomoney = Math.round(member_price / 100.00);

        rrp_price = (Math.round(rrp_price / 100.00) * 100).toFixed(2);
        non_member_price = (Math.round(non_member_price / 100.00) * 100).toFixed(2);
        member_price = (Math.round(member_price / 100.00) * 100).toFixed(2);

        // Discount calculating
        if(tierObj != undefined && tierObj != null){
            if (base_value === 'RRP Item' || base_value === 'RRP Total') {
                let applytheDiscount = rrp_price - member_price;
                 member_saving = (applytheDiscount).toFixed(2);
            } else {
                let applytheDiscount = non_member_price - member_price;
                 member_saving = (applytheDiscount).toFixed(2);
            }
        }
    } else {
        rrp_pricenomoney = Math.round(rrp_price / 100.00);
        non_member_pricenomoney = Math.round(non_member_price / 100.00);
        member_pricenomoney = Math.round(member_price / 100.00);

        rrp_price = (rrp_price / 100.00).toFixed(precision_option);
        non_member_price = (non_member_price / 100.00).toFixed(precision_option);
        member_price = (member_price / 100.00).toFixed(precision_option);

        // Discount calculating
        if(tierObj != undefined && tierObj != null){
            if (base_value === 'RRP Item' || base_value === 'RRP Total') {
                let applytheDiscount = rrp_price - member_price;
                 member_saving = (applytheDiscount).toFixed(precision_option);
            } else {
                let applytheDiscount = non_member_price - member_price;
                 member_saving = (applytheDiscount).toFixed(precision_option);
            }
        }
    }
}
    else if (precision === 'wholeNum') {
    if (precision_option === 'ceil') {
        rrp_pricenomoney = Math.ceil(rrp_price / 100.00);
        non_member_pricenomoney = Math.ceil(non_member_price / 100.00);
        member_pricenomoney = Math.ceil(member_price / 100.00);

        rrp_price = (Math.ceil(rrp_price / 100.00) * 100).toFixed(2);
        non_member_price = (Math.ceil(non_member_price / 100.00) * 100).toFixed(2);
        member_price = (Math.ceil(member_price / 100.00) * 100).toFixed(2);

        // Discount calculating
        if(tierObj != undefined && tierObj != null){
            if (base_value === 'RRP Item' || base_value === 'RRP Total') {
                let applytheDiscount = rrp_price - member_price;
                 member_saving = (applytheDiscount).toFixed(2);
            } else {
                let applytheDiscount = non_member_price - member_price;
                 member_saving = (applytheDiscount).toFixed(2);
            }
        }
    } else if (precision_option === 'floor') {
        rrp_pricenomoney = Math.floor(rrp_price / 100.00);
        non_member_pricenomoney = Math.floor(non_member_price / 100.00);
        member_pricenomoney = Math.floor(member_price / 100.00);

        rrp_price = (Math.floor(rrp_price / 100.00) * 100).toFixed(2);
        non_member_price = (Math.floor(non_member_price / 100.00) * 100).toFixed(2);
        member_price = (Math.floor(member_price / 100.00) * 100).toFixed(2);

        // Discount calculating
        if(tierObj != undefined && tierObj != null){
            if (base_value === 'RRP Item' || base_value === 'RRP Total') {
                let applytheDiscount = rrp_price - member_price;
                 member_saving = (applytheDiscount).toFixed(2);
            } else {
                let applytheDiscount = non_member_price - member_price;
                 member_saving = (applytheDiscount).toFixed(2);
            }
        }
    }
}
// Output the results to console or use them as needed
var member_saving_icon = 0;
if(rrp_price != 0 && rrp_price != ''){
 member_saving_icon =  (rrp_price - non_member_price);
}
rrp_price = globalFields.formatMoney(rrp_price * 100, globalFields.amount);
non_member_price = globalFields.formatMoney(non_member_price * 100, globalFields.amount);
member_price = globalFields.formatMoney(member_price * 100, globalFields.amount);
member_saving = globalFields.formatMoney(member_saving, globalFields.amount);
member_saving_icon = globalFields.formatMoney(member_saving_icon * 100, globalFields.amount);
   if(rrp_price == non_member_price){
    jQuery('.product-form--regular .rrp_wrapper').hide();
   }else{
    jQuery('.product-form--regular .rrp_wrapper').show();
   }
    jQuery('.anncodeRRPPrice').text(rrp_price);
    jQuery('.product-form--regular .anncodeNonMemberPrice').text(non_member_price);
    
    if(member_price == '$0.00'){
    jQuery('.product-form--regular .cru_price_wrapper').hide();
      
    }else{
    jQuery('.product-form--regular .anncodeMemberPrice').text(member_price);
      
    }
    
      if(member_saving == '$0.00'){
    jQuery('.product-form--regular .cru_saving_wrapper').hide();
      }else{
    jQuery('.anncodeSavingPrice').text(member_saving);
        
      }
    jQuery('.anncodeSavingIcon').text(member_saving_icon);
    if(member_saving_icon == '$0.00'){
      jQuery('.pdp_product_badge').hide();
    }else{
      jQuery('.pdp_product_badge').show();
    }
   return true;
    
  }
}
var globalFieldsProductPage_AC = new ACDiscountApp.PDPage.Global(), displayTiers = new ACDiscountApp.PDPage.DisplayTiers();
